import isplainobject from 'lodash.isplainobject'

// const whiteList = ['material']

function isLegalData(data) {
  if (Array.isArray(data)) { // 数组类型
    return data.length > 0
  }

  return isplainobject(data)
}

function getRecommendedKey(type) {
  return type === 'pc' ? 'pcImageRecommended' : 'mobileImageRecommended'
}

function objectPlatformHandler(moduleData, key, resolveData, type) {
  const recommendedKey = getRecommendedKey(type)

  if (moduleData[recommendedKey]) {
    resolveData[key] = moduleData
  }
}

function arrayCommonHandler(moduleData, key, resolveData) {
  const recommendedData = moduleData.filter(item => {
    return item.recommended
  })

  if (recommendedData.length > 0) {
    resolveData[key] = recommendedData
  }
}

function arrayLiveHandler(moduleData, key, resolveData) {
  moduleData.forEach(item => {
    const lives = item.data

    const resolveLives = lives.filter(live => {
      return live.recommended
    })

    if (resolveLives.length > 0) {

      const target = {
        ...item,
        data: resolveLives
      }

      if (!resolveData[key]) { // 为空
        resolveData[key] = [target]
      } else {
        resolveData[key].push(target)
      }
    }
  })
}

function arrayPlatformHandler(moduleData, key, resolveData, type) {
  const recommendedKey = getRecommendedKey(type)

  const recommendedData = moduleData.filter(item => {
    return item[recommendedKey]
  })

  if (recommendedData.length > 0) {
    resolveData[key] = recommendedData
  }
}

const handlerConfig = {
  introduction: objectPlatformHandler,
  schedule: arrayPlatformHandler,
  news: arrayCommonHandler,
  live: arrayLiveHandler,
  guest: arrayCommonHandler,
  booth: arrayCommonHandler,
  activity: arrayCommonHandler,
  partner: objectPlatformHandler,
  enterprise: objectPlatformHandler,
  cases: objectPlatformHandler,
  credit: objectPlatformHandler
}

export const resolveRecommendData = (_modules, _moduleInfo, platformType) => {
  const resolveData = {}
  const sortModuleInfo = {}

  for (let i = 0; i < _modules.length; i++) {
    const moduleItem = _modules[i]

    const _key = `${moduleItem.router}_${moduleItem.moduleIndex}`

    if (_moduleInfo[_key]) { // 存在
      sortModuleInfo[_key] = _moduleInfo[_key]
    }
  }

  Object.keys(sortModuleInfo).filter(moduleKey => {
    if (moduleKey.indexOf('material') > -1) {
      return false
    }

    return isLegalData(sortModuleInfo[moduleKey])
  }).forEach(moduleKey => {
    const moduleItemInfo = sortModuleInfo[moduleKey]
    try {
      const arr = moduleKey.split('_')
      handlerConfig[arr[0]](moduleItemInfo, moduleKey, resolveData, platformType)
    } catch (error) {
      console.log(error)
    }
  })

  return resolveData
}
